import { render, staticRenderFns } from "./textarea_plus.vue?vue&type=template&id=2cdf7814"
import script from "./textarea_plus.vue?vue&type=script&lang=js"
export * from "./textarea_plus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports